exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".blank[data-v-1ad2d1f8]{visibility:hidden;height:0}.eg[data-v-1ad2d1f8]{margin-top:30px}.about-eg[data-v-1ad2d1f8]{line-height:25px;color:#616161;font-size:16px;padding:0 35px}.about-eg p[data-v-1ad2d1f8]:last-child{margin-top:10px}", "", {"version":3,"sources":["/./src/components/About.vue"],"names":[],"mappings":"AACA,wBAAwB,kBAAkB,QAAQ,CACjD,AACD,qBAAqB,eAAe,CACnC,AACD,2BAA2B,iBAAiB,cAAc,eAAe,cAAc,CACtF,AACD,wCAAwC,eAAe,CACtD","file":"About.vue","sourcesContent":["\n.blank[data-v-1ad2d1f8]{visibility:hidden;height:0\n}\n.eg[data-v-1ad2d1f8]{margin-top:30px\n}\n.about-eg[data-v-1ad2d1f8]{line-height:25px;color:#616161;font-size:16px;padding:0 35px\n}\n.about-eg p[data-v-1ad2d1f8]:last-child{margin-top:10px\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-1ad2d1f8&scoped=true!./~/sass-loader?sourceMap!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/About.vue
// module id = 241
// module chunks = 2